<template>
    <div class="border-white select-profile h-100 overflow-hidden">
        <header class="d-flex align-items-center py-2 px-3 text-black font-size-md header-custom-border">
            <span class="fw-bold" v-show="profileType"> Share {{ capitalizeFirstLetter(profileType) }} Profile </span>
            <i class="ms-auto fas fa-times-circle grey-secondary-text cursor-pointer" @click="cancel()"></i>
        </header>
        <form @submit.prevent>
            <div class="input-group px-3 py-2">
                <input type="text" class="form-control" :placeholder="getSearchPlaceholder" v-model="search" v-focus />
                <div class="input-group-append">
                    <div class="input-group-text">
                        <i class="fas fa-search"></i>
                    </div>
                </div>
            </div>
        </form>
        <div class="height-80">
            <ScrollPagination
                class="content-y height-90"
                :page-number="pageNumber"
                :all-pages-loaded="allPagesLoaded"
                :is-loading="loadMore"
                :has-error="hasError"
                v-on:pageNumberUpdate="pageNumberUpdated"
            >
                <section
                    class="d-flex flex-column overflow-auto h-100 flex-nowrap scroll-paginate"
                    :class="`${userOs == 'Windows' ? 'custom-scrollbar' : ''}`"
                >
                    <div class="form-group" v-if="!isLoading && !hasError">
                        <template v-if="lists.length">
                            <div class="custom-border-bottom test-class" v-for="list in lists" :key="list.id">
                                <div class="form-check custom-checkbox mx-3 pt-2 pb-1">
                                    <input
                                        class="form-check-input test"
                                        type="checkbox"
                                        name="advance_care"
                                        :id="`${
                                            profileType == SelectProfileEnum.Employee
                                                ? list.sourceUserId
                                                : list.patientId
                                        }`"
                                        :value="list"
                                        v-model="selectedOptions"
                                    />
                                    <label
                                        class="form-check-label fw-bold"
                                        :for="`${
                                            profileType == SelectProfileEnum.Employee
                                                ? list.sourceUserId
                                                : list.patientId
                                        }`"
                                        >{{ capitalizeFirstLetter(list.lastName + " " + list.firstName) }}
                                    </label>
                                </div>
                                <div class="mx-4 px-3 pb-2">
                                    <div v-if="profileType == SelectProfileEnum.Patient" class="d-flex font-size-sm">
                                        <span class="me-2 patient-mrn"
                                            ><span class="fw-semibold">MRN: </span>{{ list.mrn }}</span
                                        >
                                        <span class="text-capitalize"
                                            ><span class="fw-semibold">| Status: </span
                                            >{{
                                                list.status === PatientStatusEnum.nonadmitted
                                                    ? "Non-Admit"
                                                    : PatientStatus.getDescriptionUsingValue(list.status)
                                            }}</span
                                        >
                                    </div>
                                    <div class="pt-1">
                                        <ProductPill
                                            class="application-name"
                                            :product-id="getApplicationId(list.application)"
                                        />
                                        <span class="text-default font-size-xs ms-2" style="margin-top: 2px">{{
                                            list.agencyName
                                        }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="py-1" v-if="loadMore">
                                <div class="loader-parent">
                                    <div class="msg-loader"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else> <div class="text-center font-size-md py-2">No Matches Found</div> </template>
                    </div>
                    <!-- WAITING -->
                    <p
                        v-if="isLoading && !hasError"
                        class="d-flex flex-column h-100 align-items-center justify-content-center loading"
                    >
                        <span class="loading_modal">
                            <i class="fa fa-heart heartbeat"></i>
                            <br />
                            <br />
                            <span class="title">LOADING</span>
                        </span>
                    </p>
                    <!-- ERROR -->
                    <div v-if="hasError && !isLoading" class="error-state">
                        <p>There was a problem while fetching your {{ profileType }}.<br />Please try again.</p>
                        <button
                            class="btn btn-primary"
                            @click="
                                `${
                                    profileType == SelectProfileEnum.Employee ? getUsersList('') : fetchPatientsList('')
                                }`
                            "
                        >
                            Try Again
                        </button>
                    </div>
                </section>
            </ScrollPagination>
            <div class="mt-auto ps-3 pt-1 d-flex w-100 height-10 align-items-center send-footer" v-if="!isLoading">
                <!-- Scrollable selected names -->
                <div class="selected-names-scroll" ref="selectedNamesScroll">
                    <span
                        v-for="(selectedOption, index) in selectedOptions"
                        :key="selectedOption.id"
                        class="blue-text selected-name"
                    >
                        {{ capitalizeFirstLetter(selectedOption.lastName + " " + selectedOption.firstName) }}
                        <span v-if="index < selectedOptions.length - 1">, </span>
                    </span>
                </div>
                <div class="send-btn-wrapper">
                    <button
                        class="btn border-0 pt-0"
                        :disabled="selectedOptions.length === 0"
                        @click="updateSelectedItems()"
                    >
                        <img src="../../../assets/images/chat/send.svg" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style src="./SelectProfile.scss"></style>
<script lang="ts" src="./SelectProfile.ts"></script>
